import React from "react";
import LogoImg from "../../assets/LogoCBT.png";
import { browserName } from 'react-device-detect';
import { Link } from "react-router-dom";

const LogoHeader = () => {
  return (
    <>
      <header className="header top-0 left-0 w-full px-5">
        {/* {
        browserName!=="Chrome" ? (<div className="w-full  bg-yellow-200 text-center !text-[14px] font-semibold text-gray-800">
        This application is optimized to run only on Google Chrome for the best experience

        </div>):(
          <></>
        )
      } */}

        <nav className="bg-white  w-full z-20  border-b shadow-sm border-gray-200">
          <div className="max-w-screen-xl flex flex-wrap items-center justify-start  p-2">
            <Link to="/" className="flex items-center space-x-3">
                 <div className="w-full h-8  overflow-hidden flex items-center justify-center">
                        <img src={LogoImg} alt="Logo" className="w-full h-full object-cover" />
                    </div>
            </Link>
          </div>
        </nav>
      </header>
    </>
  );
};

export default LogoHeader;
